import React from 'react';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from '@mui/material';
import { useUnlayerDraftContext } from '@/context/UnlayerDraftContext';
import { useUnlayerComposeInteractionsContext } from '@/context/UnlayerComposeInteractionsContext';

/**
 * Warns before replacing in-progress editor changes with another saved draft.
 */
export const ReplaceDraftDialog = () => {
	const {
		isDraftReplaceDialogOpen,
		setIsDraftReplaceDialogOpen,
		setPendingDraftSelectionId,
	} = useUnlayerDraftContext();
	const { handleReplaceDraft } = useUnlayerComposeInteractionsContext();

	const handleClose = () => {
		setIsDraftReplaceDialogOpen(false);
		setPendingDraftSelectionId('');
	};

	return (
		<Dialog open={isDraftReplaceDialogOpen} onClose={handleClose} fullWidth maxWidth='sm'>
			<DialogTitle>Replace Unsaved Changes?</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Selecting a different draft will replace your current unsaved editor changes.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Cancel</Button>
				<Button variant='contained' onClick={handleReplaceDraft}>
					Replace
				</Button>
			</DialogActions>
		</Dialog>
	);
};
